import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';
/*
  Generated class for the EncuestasProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EncuestasProvider {
  private api: string;
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
  }

  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
    return this.http.post(this.api + "encuesta/listaencuesta.php", parametros, options).map(
      (response) => {
        
        return response.json();

      }
    ).catch(this.handleError);
  }
  // Devuelve todas las preguntas.
  public listapreguntas(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "dispositivo": this.global.guid,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api + "encuesta/lista.php", parametros, options).map(
      (response) => {
      
        
        return response.json();

      }
    ).catch(this.handleError);
  }
  public listapreguntascab(clavecongreso,claveencuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "dispositivo": this.global.guid,
      "clavecongreso": clavecongreso,
      "claveencuesta": claveencuesta
    };
   
    return this.http.post(this.api + "encuesta/listacab.php", parametros, options).map(
      (response) => {
      
        
        return response.json();

      }
    ).catch(this.handleError);
  }
  public resultados(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api + "encuesta/resultados.php", parametros, options).map(
      (response) => {
      
        
        return response.json();

      }
    ).catch(this.handleError);
  }
  public deletecab(nencuesta): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "encuestascab",
      "clave": nencuesta,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }
   // Elimina un congreso
   public delete(nencuesta): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "encuesta",
      "clave": nencuesta,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }
  public insertcab(congreso,encuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    encuesta.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "encuestascab",
      "parametros": encuesta
    };
  
    
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public updatecab(congreso,encuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "encuestascab",
      "clave": encuesta.clave,
      "parametros": encuesta
    };
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
         
         return respuesta[0];
      }
    ).catch(this.handleError);
  }
  // Inserta un congreso nuevo
  public insert(congreso,encuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    encuesta.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "encuesta",
      "parametros": encuesta
    };
  
    
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso,encuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "encuesta",
      "clave": encuesta.clave,
      "parametros": encuesta
    };
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
         
         return respuesta[0];
      }
    ).catch(this.handleError);
  }

   // Devuelve todas las preguntas.
   public generapreguntas(clavecongreso,cabencuesta ): Observable<any> {
    var claveencuesta=0;
    if(cabencuesta!=null){
      claveencuesta=cabencuesta.clave;
    }
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso,
      "claveencuesta":claveencuesta
    };
    
    return this.http.post(this.api + "encuesta/encuestadefecto.php", parametros, options).map(
      (response) => {
       
        return response.json();

      }
    ).catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  public enviarespuestas(clavecongreso,encuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "dispositivo": this.global.guid,
      "clavecongreso": clavecongreso,
      "encuesta":encuesta
    };
   
    return this.http.post(this.api + "encuesta/grabarespuestas.php", parametros, options).map(
      (response) => {
     
        return response.json();

      }
    ).catch(this.handleError);
  }

  public ordena(congreso,encuestas): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "encuesta",
      "parametros": encuestas
    };
   
    return this.http.post(this.api+"apigen/orden.php", parametros, options).map(
      (response) => {
        
        return response.json(); 
      }
    ).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/providers/encuestas/encuestas.ts